const angular = require('angular')
const contactService = require('./contactService')
const secondAuthService = require('./secondAuthService')
const httpInterceptor = require('./httpInterceptor')
const phoneModal = require('./phoneModal')
const globalMailService = require('./globalMailService')
const globalFolderService = require('./globalFolderService')
const wechatService = require('./wechatService')

module.exports = angular.module('hxphone.services', [])
  .factory('contactService', contactService) // 联系人服务
  .factory('secondAuthService', secondAuthService) // 二次验证服务
  .factory('HttpInterceptor', httpInterceptor) // http拦截器服务
  .factory('$phoneModal', phoneModal) // 全屏模态框服务
  .factory('globalMailService', globalMailService) // 全局邮件服务
  .factory('globalFolderService', globalFolderService) // 全局文件夹服务
  .factory('wechatService', wechatService) // 微信环境服务



// WEBPACK FOOTER //
// ./src/js/services/module.js